import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
const OurServices = () => {
    const [lang, setLang] = useState("En");
    useEffect(() => {
        if (localStorage.getItem("language") === "En") {
            setLang("En");
        } else if (localStorage.getItem("language") === "Fr") {
            setLang("Fr");
        }
    }, []);
    return (
        <section
            id="services"
            class="services"
            // style={{
            //     backgroundImage: "url(services-bg.jpg)",
            //     backgroundSize: "100%",
            // }}
            style={{ backgroundColor: "#242424" }}
        >
            <a name="services" />
            <div>
                <div class="container">
                    <div
                        class="text-center top-text"
                        // style={{ paddingTop: "20px" }}
                    >
                        {lang === "Fr" ? (
                            <h1
                                style={{ fontSize: "48px", paddingTop: "20px" }}
                            >
                                PRODUITS <span>ET</span> SERVICES
                            </h1>
                        ) : (
                            <h1
                                style={{ fontSize: "48px", paddingTop: "20px" }}
                            >
                                Product <span>&</span> Services
                            </h1>
                        )}
                        <h4>
                            {lang === "Fr"
                                ? `CE QUE NOUS FAISONS`
                                : `What We Doing`}
                        </h4>
                    </div>
                    <div class="divider text-center">
                        <span class="outer-line"></span>
                        <span class="fa fa-cogs" aria-hidden="true"></span>
                        <span class="outer-line"></span>
                    </div>

                    <div
                        class="row services-box"
                        style={{ display: "flex", justifyContent: "center" }}
                    >
                        <div
                            class="col-lg-4 col-md-12 col-sm-12 services-box-item "
                            style={{ width: "349px", height: "222px" }}
                            data-aos="zoom-in"
                        >
                            <span
                                class="services-box-item-cover fa fa-leaf"
                                data-headline={
                                    lang === "Fr"
                                        ? `Produit en Or`
                                        : `Gold Product`
                                }
                            ></span>

                            <div
                                class="services-box-item-content fa fa-leaf"
                                style={{ width: "349px", height: "247px" }}
                            >
                                <h2 style={{ fontSize: "28px" }}>{
                                    lang === "Fr"
                                        ? `Produit Gold`
                                        : `Gold Product`
                                }</h2>
                                <p>
                                    {lang === "Fr"
                                        ? `Barres Dore: Jusqu’à 10Kg.`
                                        : `Dore Bars: Up to 10Kg...`}
                                    <br />
                                    <span
                                        style={{
                                            fontSize: "18px",
                                            color: "rgb(218 165 32)",
                                        }}
                                    >
                                        <Link to="/products-services">
                                            {lang === "Fr"
                                                ? `LIRE LA SUITE`
                                                : `Read More ...`}
                                        </Link>
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div
                            class="col-lg-4 col-md-12 col-sm-12 services-box-item"
                            style={{ width: "349px", height: "222px" }}
                            data-aos="zoom-in"
                        >
                            <span
                                class="services-box-item-cover fa fa-anchor"
                                data-headline={
                                    lang === "Fr"
                                        ? `Quantités d’or`
                                        : `Gold Quantities`
                                }
                            ></span>

                            <div
                                class="services-box-item-content fa fa-anchor"
                                style={{ width: "349px", height: "247px" }}
                            >
                                <h2 style={{ fontSize: "28px" }}>
                                    {lang === "Fr"
                                        ? `Quantités d’or`
                                        : `Gold Quantities`}
                                </h2>
                                <p>
                                    {lang === "Fr"
                                        ? `Commandes ponctuelles :
25 kg à 500 kg. Ordres de
fabrication pour des durées
de 12 mois ou plus... `
                                        : `One-Time Spot Orders: 25Kg to 500Kg.
                                    Production Orders for Terms of 12 Months or
                                    Longer...`}
                                    <br />
                                    <span
                                        style={{
                                            fontSize: "18px",
                                            color: "rgb(218 165 32)",
                                        }}
                                    >
                                        <Link to="/products-services">
                                            {lang === "Fr"
                                                ? `LIRE LA SUITE`
                                                : `Read More ...`}
                                        </Link>
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div
                            class="col-lg-4 col-md-12 col-sm-12 services-box-item"
                            style={{ width: "349px", height: "222px" }}
                            data-aos="zoom-in"
                        >
                            <span
                                class="services-box-item-cover fa fa-hand-holding-usd"
                                data-headline={
                                    lang === "Fr"
                                        ? `Prix de l’or`
                                        : `Gold Pricing`
                                }
                            ></span>

                            <div
                                class="services-box-item-content fa fa-hand-holding-usd"
                                style={{ width: "349px", height: "247px" }}
                            >
                                <h2 style={{ fontSize: "28px" }}>
                                    {lang === "Fr"
                                        ? `Prix de l’or`
                                        : `Gold Pricing`}
                                </h2>
                                <p>
                                    {lang === "Fr"
                                        ? `Les prix sont indexés sur le
Bourse des métaux de
Londres (London Metal
Exchange (LME))...`
                                        : `Prices are indexed to the London Metal
                                    Exchange (LME)...`}
                                    <br />
                                    <span
                                        style={{
                                            fontSize: "18px",
                                            color: "rgb(218 165 32)",
                                        }}
                                    >
                                        <Link to="/products-services">
                                            {lang === "Fr"
                                                ? `LIRE LA SUITE`
                                                : `Read More ...`}
                                        </Link>
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div
                            class="col-lg-4 col-md-12 col-sm-12 services-box-item"
                            style={{ width: "349px", height: "222px" }}
                            data-aos="zoom-in"
                        >
                            <span
                                class="services-box-item-cover fa fa-clipboard-check"
                                data-headline={
                                    lang === "Fr"
                                        ? `Livraison/logistique des produits`
                                        : `Product Delivery/Logistics`
                                }
                            ></span>
                            <div
                                class="services-box-item-content fa fa-clipboard-check"
                                style={{ width: "349px", height: "247px" }}
                            >
                                <h2 style={{ fontSize: "28px" }}>
                                    {lang === "Fr"
                                        ? `Livraison/logistique des produits`
                                        : `Product Delivery/Logistics`}
                                </h2>
                                <p>
                                    {" "}
                                    {lang === "Fr"
                                        ? `Quantité , Distance , Mode
de transport. Exigences en
matière de sécurité et de
main-d’œuvre.`
                                        : `Quantity , Distance , Form of
                                    transportation. Security/manpower
                                    requirements...`}{" "}
                                    <br />
                                    <span
                                        style={{
                                            fontSize: "18px",
                                            color: "rgb(218 165 32)",
                                        }}
                                    >
                                        <Link to="/products-services">
                                            {lang === "Fr"
                                                ? `LIRE LA SUITE`
                                                : `Read More ...`}
                                        </Link>
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div
                            class="col-lg-4 col-md-12 col-sm-12 services-box-item"
                            style={{ width: "349px", height: "222px" }}
                            data-aos="zoom-in"
                        >
                            <span
                                class="services-box-item-cover fa fa-cogs"
                                data-headline={
                                    lang === "Fr"
                                        ? `Trouver de vrais vendeurs et des acheteurs
compétents`
                                        : `Finding true sellers and capable buyers`
                                }
                            ></span>

                            <div
                                class="services-box-item-content fa fa-cogs"
                                style={{ width: "349px", height: "247px" }}
                            >
                                <h2 style={{ fontSize: "28px" }}>
                                    {lang === "Fr"
                                        ? `Trouver de vrais vendeurs et des acheteurs
compétents`
                                        : `Finding true sellers and capable buyers`}
                                </h2>
                                <p>
                                    <span
                                        style={{
                                            fontSize: "18px",
                                            color: "rgb(218 165 32)",
                                        }}
                                    >
                                        <Link to="/products-services">
                                            {lang === "Fr"
                                                ? `LIRE LA SUITE`
                                                : `Read More ...`}
                                        </Link>
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div
                            class="col-lg-4 col-md-12 col-sm-12 services-box-item"
                            style={{ width: "349px", height: "222px" }}
                            data-aos="zoom-in"
                        >
                            <span
                                class="services-box-item-cover fa fa-shield-alt"
                                data-headline={
                                    lang === "Fr"
                                        ? `Exigences en
matière de sécurité et de main-d’œuvre`
                                        : `Security/manpower requirements`
                                }
                            ></span>

                            <div
                                class="services-box-item-content fa fa-shield-alt"
                                style={{ width: "349px", height: "247px" }}
                            >
                                <h2 style={{ fontSize: "28px" }}>
                                    {lang === "Fr"
                                        ? `Exigences en
matière de sécurité et de main-d’œuvre`
                                        : `Security/manpower requirements`}
                                </h2>
                                <p>
                                    <span
                                        style={{
                                            fontSize: "18px",
                                            color: "rgb(218 165 32)",
                                        }}
                                    >
                                        <Link to="/products-services">
                                            {lang === "Fr"
                                                ? `LIRE LA SUITE`
                                                : `Read More ...`}
                                        </Link>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurServices;
